import { projectDeliveredKey } from 'root/src/shared/constants/keys'

import { APPROVE_DELIVERY_BRAND } from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'
import { REVIEW_DELIVERY_BRAND } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { BRAND_PENDING_DELIVERIES_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[APPROVE_DELIVERY_BRAND]: {
		endpointId: REVIEW_DELIVERY_BRAND,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['audit', projectDeliveredKey],
		],
		label: 'Approve dare',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectDeliveredKey,
			},
		],
		onSuccessRedirect: { routeId: BRAND_PENDING_DELIVERIES_ROUTE_ID },
	},
}
